<h1 mat-dialog-title>{{ titleLabel | translate }}</h1>

<mat-dialog-content class="mat-typography">

  <!-- FORM -->
  <div class="form" *ngIf="form">
    <form [formGroup]="form">

      <!-- Label del metodo di pagamento -->
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>{{ 'ADD_NEW_PAYMENT_METHOD.PAYMENT_METHOD_LABEL' | translate }}</mat-label>
        <input matInput formControlName="label" [placeholder]="'ADD_NEW_PAYMENT_METHOD.PAYMENT_METHOD_PLACEHOLDER' | translate">
        <mat-error *ngIf="form.get('label')?.hasError('required')">
          {{ 'ADD_NEW_PAYMENT_METHOD.REQUIRED_FIELD' | translate }}
        </mat-error>
      </mat-form-field>

      <!-- Sezione Steps -->
      <div class="steps-section">
        <h3>{{ 'ADD_NEW_PAYMENT_METHOD.PAYMENT_STEPS_TITLE' | translate }}</h3>

        <!-- Messaggio informativo -->
        <div class="info-message" style="margin-bottom: 16px;">
          <mat-icon>info</mat-icon>
          <span><strong>{{ 'ADD_NEW_PAYMENT_METHOD.NOTE' | translate }}:</strong> {{ 'ADD_NEW_PAYMENT_METHOD.SALDO_REQUIRED_INFO' | translate }}</span>
        </div>

        <!-- Selezione tipologia per nuovo step -->
        <div class="add-step-section">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'ADD_NEW_PAYMENT_METHOD.SELECT_STEP_TYPE' | translate }}</mat-label>
            <mat-select [(ngModel)]="selectedTipoForNewStep" [ngModelOptions]="{standalone: true}">
              <mat-option *ngFor="let tipo of getAvailableTypes()" [value]="tipo.id">
                {{ tipo.label | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-raised-button color="primary" (click)="addStep()" [disabled]="selectedTipoForNewStep === null">
            <mat-icon>add</mat-icon> {{ 'ADD_NEW_PAYMENT_METHOD.ADD_STEP' | translate }}
          </button>
        </div>

        <!-- Lista degli step -->
        <div formArrayName="steps" class="steps-list">
          <mat-accordion>
            <mat-expansion-panel #panel *ngFor="let step of steps.controls; let i = index" 
                                 [formGroupName]="i" 
                                 [expanded]="true"
                                 class="step-card">
              
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <div class="step-title-full">
                    <mat-icon>{{ step.get('TipoFatturazioneId')?.value === 2 ? 'start' : (step.get('TipoFatturazioneId')?.value === 4 ? 'flag' : 'timeline') }}</mat-icon>
                    <strong>{{ step.get('label')?.value || getTipoLabel(step.get('TipoFatturazioneId')?.value) }}</strong>
                    <span class="step-order">{{ 'ADD_NEW_PAYMENT_METHOD.STEP_PREFIX' | translate }} {{ step.get('order')?.value }}</span>
                    <mat-icon class="step-invalid-icon" *ngIf="step.invalid && !panel.expanded" [matTooltip]="'ADD_NEW_PAYMENT_METHOD.STEP_HAS_ERRORS' | translate">error</mat-icon>
                  </div>
                </mat-panel-title>
                <mat-panel-description>
                  <div class="step-actions">
                    <!-- Bottoni per riordinare (solo per RATE) -->
                    <button mat-icon-button 
                            *ngIf="canMoveStep(i) && i > 0" 
                            (click)="$event.stopPropagation(); moveStepUp(i)"
                            [disabled]="!canMoveStep(i) || steps.at(i-1).get('TipoFatturazioneId')?.value !== 3"
                            [matTooltip]="'ADD_NEW_PAYMENT_METHOD.MOVE_UP' | translate">
                      <mat-icon>arrow_upward</mat-icon>
                    </button>
                    <button mat-icon-button 
                            *ngIf="canMoveStep(i) && i < steps.length - 1" 
                            (click)="$event.stopPropagation(); moveStepDown(i)"
                            [disabled]="!canMoveStep(i) || steps.at(i+1).get('TipoFatturazioneId')?.value !== 3"
                            [matTooltip]="'ADD_NEW_PAYMENT_METHOD.MOVE_DOWN' | translate">
                      <mat-icon>arrow_downward</mat-icon>
                    </button>
                    <button mat-icon-button color="warn" (click)="$event.stopPropagation(); removeStep(i)" [matTooltip]="'ADD_NEW_PAYMENT_METHOD.REMOVE_STEP' | translate">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <div class="step-content">
              <div class="step-row">
                <!-- Percentage -->
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'ADD_NEW_PAYMENT_METHOD.BILLING_PERCENTAGE' | translate }}</mat-label>
                  <input matInput formControlName="percentage" type="number" min="0" max="100" step="1"
                         (input)="onPercentageChange()">
                  <mat-error *ngIf="step.get('percentage')?.hasError('required')">
                    {{ 'ADD_NEW_PAYMENT_METHOD.REQUIRED_FIELD' | translate }}
                  </mat-error>
                  <mat-error *ngIf="step.get('percentage')?.hasError('min') || step.get('percentage')?.hasError('max')">
                    {{ 'ADD_NEW_PAYMENT_METHOD.VALUE_RANGE' | translate }}
                  </mat-error>
                </mat-form-field>

                <!-- Progressive Percentage -->
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'ADD_NEW_PAYMENT_METHOD.PROGRESSIVE_BILLING_PERCENTAGE' | translate }}</mat-label>
                  <input matInput formControlName="progressivePercentage" type="number" readonly>
                </mat-form-field>
              </div>

              <div class="step-row">
                <!-- End of Work - Non visibile per ACCONTO, readonly per SALDO -->
                <mat-checkbox formControlName="endOfWork" 
                              *ngIf="step.get('TipoFatturazioneId')?.value !== 2"
                              [disabled]="step.get('TipoFatturazioneId')?.value === 4">
                  {{ 'ADD_NEW_PAYMENT_METHOD.END_OF_WORK' | translate }}
                </mat-checkbox>

                <!-- Info per SALDO -->
                <div class="info-message" *ngIf="step.get('TipoFatturazioneId')?.value === 4">
                  <mat-icon>info</mat-icon>
                  <span>{{ 'ADD_NEW_PAYMENT_METHOD.SALDO_END_OF_WORK_INFO' | translate }}</span>
                </div>

                <!-- Days from End of Work -->
                <mat-form-field appearance="outline" *ngIf="(step.get('endOfWork')?.value && step.get('TipoFatturazioneId')?.value !== 2) || step.get('TipoFatturazioneId')?.value === 3">
                  <mat-label>{{ 'ADD_NEW_PAYMENT_METHOD.INVOICE_DUE_DAYS' | translate }}</mat-label>
                  <input matInput formControlName="dayFromEndOfWork" type="number" min="0" step="1">
                  <mat-error *ngIf="step.get('dayFromEndOfWork')?.hasError('required')">
                    {{ 'ADD_NEW_PAYMENT_METHOD.REQUIRED_FIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="step-row">
                <!-- Monthly Payment - Visibile solo per RATA -->
                <mat-checkbox formControlName="monthlyPayment" *ngIf="step.get('TipoFatturazioneId')?.value === 3">
                  {{ 'ADD_NEW_PAYMENT_METHOD.MONTHLY_PAYMENT' | translate }}
                </mat-checkbox>

                <!-- Percentage SAL - Non visibile se monthlyPayment è true o se è ACCONTO -->
                <mat-form-field appearance="outline" 
                                *ngIf="!step.get('monthlyPayment')?.value && step.get('TipoFatturazioneId')?.value !== 2">
                  <mat-label>{{ 'ADD_NEW_PAYMENT_METHOD.SAL_PERCENTAGE' | translate }}</mat-label>
                  <input matInput formControlName="percentageSAL" type="number" min="0" max="100" step="1"
                         [readonly]="step.get('TipoFatturazioneId')?.value === 4">
                  <mat-error *ngIf="step.get('percentageSAL')?.hasError('required')">
                    {{ 'ADD_NEW_PAYMENT_METHOD.REQUIRED_FIELD' | translate }}
                  </mat-error>
                  <mat-error *ngIf="step.get('percentageSAL')?.hasError('min') || step.get('percentageSAL')?.hasError('max')">
                    {{ 'ADD_NEW_PAYMENT_METHOD.VALUE_RANGE' | translate }}
                  </mat-error>
                  <mat-hint *ngIf="step.get('TipoFatturazioneId')?.value === 4">{{ 'ADD_NEW_PAYMENT_METHOD.SALDO_SAL_HINT' | translate }}</mat-hint>
                </mat-form-field>

                <!-- Messaggio per ACCONTO -->
                <div class="info-message" *ngIf="step.get('TipoFatturazioneId')?.value === 2">
                  <mat-icon>info</mat-icon>
                  <span>{{ 'ADD_NEW_PAYMENT_METHOD.ACCONTO_SAL_INFO' | translate }}</span>
                </div>
              </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>

          <!-- Messaggio se non ci sono step -->
          <div *ngIf="steps.length === 0" class="no-steps-message">
            <mat-icon>info</mat-icon>
            <p>{{ 'ADD_NEW_PAYMENT_METHOD.NO_STEPS_MESSAGE' | translate }}</p>
          </div>
        </div>

        <!-- Validazioni totali -->
        <div class="validation-summary" *ngIf="steps.length > 0">
          <div class="validation-item">
            <mat-icon [class.valid]="hasSaldo()">
              {{ hasSaldo() ? 'check_circle' : 'cancel' }}
            </mat-icon>
            <span *ngIf="hasSaldo()">{{ 'ADD_NEW_PAYMENT_METHOD.SALDO_PRESENT_YES' | translate }}</span>
            <span *ngIf="!hasSaldo()">{{ 'ADD_NEW_PAYMENT_METHOD.SALDO_PRESENT_NO' | translate }}</span>
          </div>
          <div class="validation-item">
            <mat-icon [class.valid]="getTotalPercentage() === 100">
              {{ getTotalPercentageSAL() === 100 ? 'check_circle' : 'cancel' }}
            </mat-icon>
            <span>{{ 'ADD_NEW_PAYMENT_METHOD.SAL_PROGRESSIVE_SUM' | translate }} {{ getTotalPercentageSAL() }}% / 100%</span>
          </div>
          <div class="validation-item">
            <mat-icon [class.valid]="getLastProgressivePercentage() === 100">
              {{ getLastProgressivePercentage() === 100 ? 'check_circle' : 'cancel' }}
            </mat-icon>
            <span>{{ 'ADD_NEW_PAYMENT_METHOD.BILLING_PROGRESSIVE_PERCENTAGE' | translate }} {{ getLastProgressivePercentage() }}% / 100%</span>
          </div>
          <div class="validation-item validation-item--global">
            <mat-icon [class.valid]="form.valid">
              {{ form.valid ? 'check_circle' : 'cancel' }}
            </mat-icon>
            <span *ngIf="form.valid">{{ 'ADD_NEW_PAYMENT_METHOD.FORM_COMPLETE_YES' | translate }}</span>
            <span *ngIf="!form.valid">{{ 'ADD_NEW_PAYMENT_METHOD.FORM_COMPLETE_NO' | translate }}</span>
          </div>
        </div>
      </div>

    </form>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="">{{ cancelButtonLabel | translate }}</button>
  <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!canSubmit()">
    {{ confirmButtonLabel | translate }}
  </button>
</mat-dialog-actions>